/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React from "react";
import {AEInput, Card, CardBody} from "../../../../../_metronic/_partials/controls";
import {useIntl} from "react-intl";
import { AELabels} from "../../../../../_emywork/components/AELabel";
import {AESVG} from "../../../../../_emywork/components/svg";
import {AEMoment} from "../../../../../_emywork/components/moment";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {AERater} from "../../../../../_metronic/_partials/controls/forms/AERater";
import moment from "moment";
import {AEFeed} from "../../../../../_emywork/components/AEFeed";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useFormik} from "formik";
import * as ReviewActions from "../../_redux/Reviews/actions";
import {HTTP_CREATED} from "../../../../../_emywork/helpers/AxiosHelpers";

export function Profile({ entity, getEntity = () => {} }) {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const { authUser } = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );
  const Header = ({title}) => <div className='font-size-h3 pb-5'>{title}</div>

  const reviewFormik = useFormik({
    initialValues: {
      to_user_id: entity.id,
      user_id: authUser.id,
      message:"",
      rating: 0
    },
    onSubmit: values => {
      dispatch(ReviewActions.createEntity(values))
        .then(r=>{
          if(r.status === HTTP_CREATED){
            getEntity()
          }
        })
    }
  });
  const {handleSubmit, getFieldProps} = reviewFormik;

  return (
    <>
      <Card>
        <CardBody>
          <div className='gutter-b '>
            <Header title={formatMessage({id: `ABOUT`})} />
            <div>
              {entity.about}
            </div>
          </div>
          <div className=''>
            <Header title={formatMessage({id: `SKILLS`})} />
            <div>
              <AELabels limit={entity.skills.length} options={entity.skills} variant={'light'} />
            </div>
          </div>
        </CardBody>
      </Card>
      {
        entity.experiences.length > 0 &&
        <Card>
          <CardBody>
            <div className=''>
              <Header title={formatMessage({id: `EXPERIENCE`})} />

              <div className="timeline timeline-3">
                <div className="timeline-items">
                  {
                    entity.experiences.map(e=>(
                      <div key={e.id} className="timeline-item">
                        <div className="timeline-media">
                          {
                            e.ended_at ?
                              <AESVG path={'/Code/Done-circle.svg'} variant={'primary'} /> :
                              <AESVG path={'/Navigation/Minus.svg'} variant={'secondary'} />
                          }

                        </div>
                        <div className="timeline-content">
                          <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="text-dark-75 text-hover-primary font-size-h4">
                                {e.title}
                              </div>
                              <div className="-text-muted">
                                <AEMoment date={e.started_at} format={'L'} />
                                {` - `}
                                {
                                  e.ended_at ?
                                    <AEMoment date={e.ended_at} format={'L'}/> :
                                    formatMessage({id: "PRESENT"})
                                }

                              </div>
                            </div>
                            <div className="font-weight-bolder">
                              - {e.company}
                            </div>
                          </div>
                          <p className="p-0">
                            {e.description}
                          </p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      }

      {
        entity.educations.length > 0 &&
        <Card>
          <CardBody>
            <div className=''>
              <Header title={formatMessage({id: `EDUCATION`})} />

              <div className="timeline timeline-3">
                <div className="timeline-items">
                  {
                    entity.educations.map(e=>(
                      <div key={e.id} className="timeline-item">
                        <div className="timeline-media">
                          {
                            e.ended_at ?
                              <AESVG path={'/Code/Done-circle.svg'} variant={'primary'} /> :
                              <AESVG path={'/Navigation/Minus.svg'} variant={'secondary'} />
                          }

                        </div>
                        <div className="timeline-content">
                          <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="text-dark-75 text-hover-primary font-size-h4">
                                {e.title}
                              </div>
                              <div className="-text-muted">
                                <AEMoment date={e.started_at} format={'L'} />
                                {` - `}
                                {
                                  e.ended_at ?
                                    <AEMoment date={e.ended_at} format={'L'}/> :
                                    formatMessage({id: "PRESENT"})
                                }

                              </div>
                            </div>
                            <div className="font-weight-bolder">
                              - {e.school}
                            </div>
                          </div>
                          <p className="p-0">
                            {e.description}
                          </p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      }

      {
        entity.awards.length > 0 &&
        <Card>
          <CardBody>
            <div className=''>
              <Header title={formatMessage({id: `AWARDS`})} />

              <div className="timeline timeline-3">
                <div className="timeline-items">
                  {
                    entity.awards.map(e=>(
                      <div key={e.id} className="timeline-item">
                        <div className="timeline-media">
                          <AESVG path={'/General/Bookmark.svg'} variant={'primary'} />

                        </div>
                        <div className="timeline-content">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="text-dark-75 text-hover-primary font-size-h4">
                              {e.title}
                            </div>
                          </div>
                          <div className="text-muted">
                            <AEMoment date={e.achieved_at} format={'LLL'} />
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      }

      <Card>
        <CardBody>
          <div className=''>
            <Header title={formatMessage({id: `FEEDBACKS`})} />
            {
              authUser.id !== entity.id &&
              <>
                <AERater
                  field={getFieldProps('rating')}
                  form={reviewFormik}
                  borderless
                  muliple
                  withFeedbackLabel={false} validation={false}
                  name={"rating"}
                  label={"RATING"}
                  placeholder={formatMessage({id:'MESSAGE'})}
                />
                <AEInput
                  type={"textarea"}
                  className="form-control-solid font-weight-bolder"
                  rows={4}
                  field={getFieldProps('message')}
                  form={reviewFormik}
                  borderless
                  muliple
                  withFeedbackLabel={false} validation={false}
                  name={"message"}
                  label={"MESSAGE"}
                  placeholder={formatMessage({id:'COMMENT.PLACEHOLDER'})}
                />
                <AEButton
                  variant={"light-primary"}
                  fontWeight={"bolder"}
                  size={"sm"}
                  onClick={handleSubmit}
                  block
                  className={"mt-2"}
                >
                  {formatMessage({id:'SEND'})}
                  <AESVG path={"/Communication/Send.svg"} className={'pl-2'}/>

                </AEButton>
                <div className="separator separator-solid mt-9 mb-4"/>
              </>
            }

            <div className="card-scroll" style={{maxHeight: 358}}>
              {
                  [...entity.feedbacks]
                  .sort((a, b) => {
                    return moment(a.created_at).isAfter(moment(b.created_at)) ? -1 : 1
                  })
                  .map(review=>(
                    <AEFeed
                      key={review.id}
                      entity={review}
                      // isAuthor={entity.id === authUser.id}
                    />
                  ))
              }
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  )

}
